import React from 'react';
import styles from "./LearnMore.module.scss";
import { Button, CloseButton, IconButton, Typography } from 'seagull';
import servicesLogosUrl from "../../../assets/services_logos.png";
import { Clock, SecuritySafe, StatusUp, TaskSquare, WideArrowBackward } from 'seagull/icons';
import cn from 'classnames';
import { AnchorLogo } from 'seagull/icons';
const BULLETS = [{
  icon: SecuritySafe,
  title: 'Bank-level security and privacy',
  desc: 'Full data protection and complete security.'
}, {
  icon: TaskSquare,
  title: 'No surprises, guaranteed',
  desc: 'You only pay what is stated in the agreement.'
}, {
  icon: StatusUp,
  title: 'Full control and transparency',
  desc: "If something changes, you won't be billed until you approve it."
}, {
  icon: Clock,
  title: 'Time saver',
  desc: 'Quick approval of changes and payments.'
}];
export function LearnMore(_ref) {
  let {
    isDesktop,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.learnMoreModal, {
      [styles.mobile]: !isDesktop,
      [styles.desktop]: isDesktop
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", null, !isDesktop && /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(WideArrowBackward, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.vendorLogo
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    height: 48
  })), /*#__PURE__*/React.createElement("div", null, isDesktop && /*#__PURE__*/React.createElement(CloseButton, {
    skin: "transparent",
    onClick: onClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, "Core benefits of Anchor's billing platform"), BULLETS.map((bullet, i) => {
    const Icon = bullet.icon;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles.bullet
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.icon
    }, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph1"
    }, bullet.title), /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph1",
      skin: "secondary"
    }, bullet.desc));
  }), /*#__PURE__*/React.createElement("img", {
    src: servicesLogosUrl,
    className: styles.servicesLogos,
    width: "177px",
    height: "33px"
  })), !isDesktop && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    onClick: onClose
  }, "Back")));
}